import { NotificationService } from 'app/services';
import { DataService } from './../../../../services/data.service';
import { FormValidationService } from './../../../../services/form-validation.service';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-student-academic-card',
  templateUrl: './student-academic-card.component.html',
  styleUrls: ['./student-academic-card.component.scss']
})
export class StudentAcademicCardComponent implements OnChanges, OnDestroy {

  @Input() academicInputData: any;
  @Output() academicUpdate: EventEmitter<any> = new EventEmitter<any>();

  classSize = this.dataService.getEntity('Class Size').item || [];
  preferredClassSize = this.classSize.map(entry => ({
    other: entry.value,
    text: entry.text,
    value: entry.id,
    checked: false
  }));
  backendUpdate = false;
  academicForm: FormGroup;
  formsTouched = false;
  unweighted: number;
  weighted: number;
  advancedClasses = [1, 2, 3, 4, 5, 6, 7];
  private destroyed$ = new Subject();


  constructor(
    private formBuilder: FormBuilder,
    private _formValidationService: FormValidationService,
    private dataService: DataService,
    private notificationService: NotificationService
  ) {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['academicInputData'] !== undefined && changes['academicInputData'].currentValue !== undefined) {
      this.backendUpdate = true;
      this.hydrateForm(changes['academicInputData'].currentValue);
      this.backendUpdate = false;
    }
    if (this.academicForm && this.academicForm.dirty && this.academicForm.valid) {
      this.academicUpdate.emit(this.academicForm.value);

    }
  }

  buildForm() {
    this.academicForm = this.formBuilder.group({
      gpaWeighted: '',
      gpaUnweighted: '',
      satComposite: ['', Validators.compose([Validators.max(1600), Validators.min(400)])],
      actComposite: ['', Validators.compose([Validators.max(36), Validators.min(1)])],
      studies: {},
      nonStudies: false,
      preferredClassSizeId: 0,
      advancedClassTaken: 0,
      gpaUnsure: false,
      testingResultsUnknown: false
    });
    this.academicForm.valueChanges
      .filter(() => this.academicForm.valid && !this.backendUpdate)
      .pipe(debounceTime(10), takeUntil(this.destroyed$))
      .subscribe(newAcademic => this.updateAcademic());
    this._formValidationService.registerForm('academicForm', this.academicForm);
  }

  hydrateForm(newData) {

    const values = {
      gpaWeighted: (newData.gpa && newData.gpa.weighted) ? newData.gpa.weighted : '',
      gpaUnweighted: (newData.gpa && newData.gpa.unweighted) ? newData.gpa.unweighted : '',
      satComposite: newData.scores.filter(item => item.ebrw).map(item => item.ebrw)[0] || '',
      actComposite: newData.scores.filter(item => item.actComposite).map(item => item.actComposite)[0] || '',
      studies: newData.studies ? newData.studies[0] : { ap: false, ib: false, dual: false, honors: false },
      preferredClassSizeId: newData.preferredclassSizeClassIds ? newData.preferredclassSizeClassIds : [],
      nonStudies: false,
      advancedClassTaken: newData.courseValue ? newData.courseValue : 0,
      gpaUnsure: false,
      testingResultsUnknown: false
    };


    values.gpaUnsure = !(values.gpaWeighted || values.gpaUnweighted);
    values.testingResultsUnknown = !(values.satComposite || values.actComposite) || !(+values.satComposite || +values.actComposite);
    values.satComposite = +values.satComposite !== 0 ? +values.satComposite : ' ';
    values.actComposite = +values.actComposite !== 0 ? +values.actComposite : ' ';
    this.preferredClassSize.filter(item => {
      if (values.preferredClassSizeId.indexOf(item.value) > -1) {
        item['checked'] = true;
      }
    });

    this.academicForm.patchValue(values);
  }

  findStudies() {
    const studies = this.academicForm.get('studies').value;
    return studies ? (!studies.ap && !studies.ib && !studies.dual && !studies.honors) : true;
  }

  classChange(classObject) {
    this.formsTouched = true;
    if (classObject.text === 'No Preference') {
      this.preferredClassSize.filter(item => {
        item.checked = false;
      })
    } else {
      this.preferredClassSize.filter(item => {
        if (item.text === 'No Preference') {
          item.checked = false;
        }
      })
    }

    classObject.checked = !classObject.checked;

  }

  getAcademicData() {
    if (this.academicForm) {
      this.academicForm.value.preferredClassSizeId = this.getSelecetdClassSize();
      return this.academicForm;
    } else {
      return false;
    }
  }

  getSelecetdClassSize() {
    const array = [];
    for (let i = 0; i < this.preferredClassSize.length; i++) {
      if (this.preferredClassSize[i].checked) {
        array.push(this.preferredClassSize[i].value)
      }
    }
    return array;
  }

  clearTestScores() {
    if (this.academicForm.controls.satComposite.value || this.academicForm.controls.actComposite.value) {
      this.academicForm.controls.satComposite.patchValue('');
      this.academicForm.controls.actComposite.patchValue('');
    }
  }

  clearUnknownCheckbox() {
    this.academicForm.controls.testingResultsUnknown.setValue(false);
  }

  clearGPAScores() {
    if (this.academicForm.controls.gpaWeighted.value || this.academicForm.controls.gpaUnweighted.value) {
      this.academicForm.controls.gpaWeighted.patchValue('');
      this.academicForm.controls.gpaUnweighted.patchValue('');
    }
  }


  _setUnKnownGPA(value) {
    this.academicForm.controls.gpaUnsure.setValue(false);
    if (value > 4) {
      this.notificationService.show('info', 'Max value of Unweighted GPA is 4.0');
      this.academicForm.controls.gpaUnweighted.setValue('');
    }
    if (value < 0) {
      this.notificationService.show('info', 'Min value of Unweighted GPA is 0');
      this.academicForm.controls.gpaUnweighted.setValue('');
    }
  }
  _setKnownGPA(value) {
    this.academicForm.controls.gpaUnsure.setValue(false);
    if (value > 5) {
      this.notificationService.show('info', 'Max value of weighted GPA is 5.0');
      this.academicForm.controls.gpaWeighted.setValue('');
    }
    if (value < 0) {
      this.notificationService.show('info', 'Min value of weighted GPA is 0');
      this.academicForm.controls.gpaWeighted.setValue('');
    }
  }
  clearClassesTaken() {
    if (this.academicForm.controls.studies) {
      this.academicForm.controls.studies.patchValue({});
      this.academicForm.controls.advancedClassTaken.patchValue(0);
    }
  }
  updateAcademic() {
    this.formsTouched = true;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.formsTouched = false;
  }
}
